// extracted by mini-css-extract-plugin
export default {"ticketPage":"tickets_ticketPage__ytpXd","typeOfTicket":"tickets_typeOfTicket__rhE2e","switch":"tickets_switch__-R2U0","textWhite":"tickets_textWhite__RvdgW"};